import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import RequestAccessContainer, {
	RequestAccessContainerProps,
} from "../../../../components/TailoredGeneration/RequestAccessContainer/RequestAccessContainer";
import { CrmEventTargets, CrmOrgEvents, CrmUserEvents } from "../../../../constants/crm.ts";
import { useBriaTheme } from "../../../../hooks/useBriaTheme.tsx";
import { useAppStore } from "../../../../hooks/useStores";
import { OrgFeatures } from "../../../../models/billing";
import styles from "./TgRequestAccessButton.module.scss";

type Props = { inheritChildButtonStyle?: boolean } & Partial<RequestAccessContainerProps>;

const TgRequestAccessButton = ({ children, inheritChildButtonStyle = false, ...rest }: Props) => {
	const { t } = useTranslation("tg", { keyPrefix: "requestAccess" });
	const { authStore } = useAppStore();
	const { getCssVariableValue } = useBriaTheme();

	return (
		<RequestAccessContainer
			className={inheritChildButtonStyle ? undefined : styles.requestButton}
			requestTitle={t(`title`)}
			requestMessage={`${t(`message`)}`}
			requestFeature={"Tailored Models"}
			crmEvents={[
				{
					eventTarget: CrmEventTargets.ORG,
					eventType: CrmOrgEvents.ORG_REQUESTED_TAILORED_MODELS,
				},
				{
					eventTarget: CrmEventTargets.USER,
					eventType: CrmUserEvents.USER_REQUESTED_TAILORED_MODELS,
				},
			]}
			buttonMessage={t("button")}
			buttonLoading={authStore.isLoadingOrgSubscriptions}
			condition={authStore.isFeatureEnabled(OrgFeatures.TAILORED_GENERATION)}
			buttonType={"textMedium"}
			crownColor={getCssVariableValue("--primary-main-color")}
			paperClass={styles.paper}
			{...rest}
		>
			{children}
		</RequestAccessContainer>
	);
};

export default observer(TgRequestAccessButton);
